import { CheckCircle2, Save } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Field, SelectField } from "./Fields";
import { ARTIFACT_DEFS, SUBJECTS, CURRICULA, LANGUAGES } from "./constants";

export function SettingsPanel({
  subject, setSubject,
  grade, setGrade,
  curriculum, setCurriculum,
  language, setLanguage,
  targetLang, setTargetLang,
  simplifyGrade, setSimplifyGrade,
  saveLesson, setSaveLesson,
}) {
  return (
    <div className="tb-card p-5 space-y-3">
      <Label className="text-[10px] uppercase tracking-[0.22em] font-semibold text-muted-foreground">Settings</Label>
      <div className="grid grid-cols-2 gap-3">
        <SelectField label="Subject"    value={subject}    onChange={setSubject}    options={SUBJECTS} />
        <Field label="Grade" value={grade} onChange={setGrade} placeholder="8" testid="tfa-grade" />
        <SelectField label="Curriculum" value={curriculum} onChange={setCurriculum} options={CURRICULA} />
        <SelectField label="Language"   value={language}   onChange={setLanguage}   options={LANGUAGES} />
        <SelectField label="Translate to" value={targetLang} onChange={setTargetLang} options={LANGUAGES} />
        <Field label="Simplify for grade" value={simplifyGrade} onChange={setSimplifyGrade} placeholder="5" testid="tfa-simplify-grade" />
      </div>
      <label className="flex items-center gap-2 pt-2 text-sm select-none cursor-pointer">
        <input type="checkbox" checked={saveLesson} onChange={(e) => setSaveLesson(e.target.checked)} data-testid="tfa-save-lesson" className="h-4 w-4" />
        <Save className="h-3.5 w-3.5 text-muted-foreground" />
        <span>Save as Lesson Workspace</span>
      </label>
    </div>
  );
}

export function ArtifactPicker({ selected, setSelected }) {
  const toggleArtifact = (k) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(k)) next.delete(k);
      else next.add(k);
      return next;
    });
  };

  return (
    <div className="tb-card p-5">
      <div className="flex items-center justify-between">
        <Label className="text-[10px] uppercase tracking-[0.22em] font-semibold text-muted-foreground">Generate</Label>
        <button
          className="text-[11px] text-muted-foreground hover:text-foreground"
          onClick={() => setSelected(new Set(selected.size === ARTIFACT_DEFS.length ? [] : ARTIFACT_DEFS.map((a) => a.key)))}
          data-testid="tfa-toggle-all"
        >
          {selected.size === ARTIFACT_DEFS.length ? "Clear all" : "Select all"}
        </button>
      </div>
      <div className="mt-3 grid grid-cols-2 gap-2">
        {ARTIFACT_DEFS.map((a) => {
          const Icon = a.icon;
          const active = selected.has(a.key);
          return (
            <button
              key={a.key}
              onClick={() => toggleArtifact(a.key)}
              className={`flex items-center gap-2 rounded-xl p-2.5 border text-left transition ${
                active ? "border-primary/60 bg-primary/5" : "border-border hover:border-border/80 bg-card/60"
              }`}
              data-testid={`tfa-artifact-${a.key}`}
            >
              <span className={`inline-grid place-items-center h-7 w-7 rounded-lg ${a.chip}`}>
                <Icon className="h-3.5 w-3.5" />
              </span>
              <span className="text-xs font-medium flex-1">{a.label}</span>
              {active && <CheckCircle2 className="h-3.5 w-3.5 text-primary" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
